import { Radio } from './Radio'
import { StatusBadge } from './StatusBadge'
import { stepperTheme } from './Stepper'

export const components = {
  Radio,
  StatusBadge,
  Stepper: stepperTheme, // trying a different way of overriding themes
}
